/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import "@new-mg/vuetify-new-theme/dist/fontface.geometria.scss";
import "@new-mg/vuetify-new-theme/dist/style.css";

// Composables
import { createVuetify } from "vuetify";
import { NEWThemeConfig } from "@new-mg/vuetify-new-theme";
import { VDateInput } from 'vuetify/labs/VDateInput'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    locale: {
        locale: 'de-DE',
    },
    components:{
        VDateInput,
    },
    ...NEWThemeConfig} );
